module.exports = __webpack_public_path__ + "static/media/gold.ba9bbc88.png";